import index from './index.vue'
import Vue from '../../comm.js'

new Vue({
  el:'#app',
  template:"<index/>",
  components:{index}
})



// WEBPACK FOOTER //
// ./src/pages/index/index.js